export default {
    "refrigerant-temperature": {
        "menu": "Diagnostics",
        "title": "Refrigerant temperature",
        "linkTitle": "Refrigerant temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Cond_Sat_Ref_Temp',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Cond_Sat_Ref_Temp",
                            xaxis:{
                                title: "Cond_Sat_Ref_Temp"
                            },
                            yaxis:{
                                title: "Count"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                id: 1,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                id: 2,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                id: 3,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temp"
                            },
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Evap_Sat_Ref_Temp',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Evap_Sat_Ref_Temp",
                            xaxis:{
                                title: "Evap_Sat_Ref_Temp"
                            },
                            yaxis:{
                                title: "Count"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                id: 1,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                id: 2,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                id: 3,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },{
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },{
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                id: 4,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temp"
                            },
                        ],
                        'type': 'histogram',
                    }
                }
            ]
    },
    "refrigerant-health": {
        "menu": "Diagnostics",
        "title": "Refrigerant health",
        "linkTitle": "Refrigerant health",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Temperature and Pressure on Condensor",
                            xaxis: {
                                title: "Condensor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Condensor Pressure (kPa)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },


                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },

                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },

                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Press",
                                variableX: "Cond_Sat_Ref_Temp"
                            },


                        ],
                        'type': 'scatter',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Temperature and Pressure on Evaporator",
                            xaxis: {
                                title: "Evaporator  Temperature (°C)"
                            },
                            yaxis: {
                                title: "Evaporator  Pressure (kPa)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },

                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },

                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },

                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: 'markers',
                                name: "Evap_Sat_Ref_Press",
                                variableX: "Evap_Sat_Ref_Temp"
                            },

                        ],
                        'type': 'scatter',
                    }
                }


            ]
    },
    "chws": {
        "menu": "Diagnostics",
        "title": "CHW Supply Temperature",
        "linkTitle": "CHW Supply Temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Outdoor Temperature and CHWS Temperature",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "CHWS Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },

                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Outdoor Temp (°C)"
                            },
                            yaxis: {
                                title: "Header Main Supply Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Main_Supply_Temp",
                                useXAsHover: true
                            }

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 4,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Header Main Supply Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Main_Supply_Temp",
                            }

                        ],
                    }
                },
            ]
    },
    "cop": {
        "menu": "Diagnostics",
        "title": "COP",
        "linkTitle": "COP",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Overall Chiller COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Overall Chiller COP"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 2,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Cooling Load and Overall Chiller COP",
                            xaxis: {
                                title: "Cooling Load (kW)"
                            },
                            yaxis: {
                                title: "Overall Chiller COP"
                            }
                        },
                        'variable-x': 'Cooling_Load',
                        'variable-y': 'COP',
                        'mode': 'markers',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 4,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Cooling Load",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Cooling Load (kW)"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'Cooling_Load',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 5,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Power",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Power (kWh)"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'power',
                        'type': 'scatter',
                    }
                },

            ]
    },
    "system-performance": {
        "menu": "Diagnostics",
        "title": "System Performance",
        "linkTitle": "System Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                name: "Temperature",
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Main_Return_Temp",
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "CHW_Diff_Temp",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Flow Rate",
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Flow_Rate",
                            }

                        ],
                    }
                }

            ]
    },
    "chiller-performance": {
        "menu": "Diagnostics",
        "title": "Chiller Performance",
        "linkTitle": "Chiller Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Outdoor Temperature and CHWS Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                            },
                            {
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                facility_name: "SHT",
                                name: "CHW_Diff_Temp",
                            }

                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            title: "Flow Rate",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "SHT",
                                name: "Flow_Rate",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            title: "COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "CRP",
                                name: "efficiency",
                            },


                        ],
                    }
                }

            ]
    },
    "cooling-performance": {
        "menu": "Diagnostics",
        "title": "Cooling Performance",
        "linkTitle": "Cooling Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power (Chiller only) ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },


                        ],
                    }
                },

                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            "title":"Overall Chiller COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                    }
                },

            ]
    },
    "working-hours": {
        "menu": "Diagnostics",
        "title": "Working Hours",
        "linkTitle": "Working Hours",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kW)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Chillers On",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "on",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Pumps On",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "CHWP1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },
                            {
                                equipment_name: "CHWP7",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "On",
                            },



                        ],
                    }
                },
                {
                    'id': 5,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Chilled Water Delta Temp",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature Diff (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "CHW_Diff_Temp",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Flow Rate",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Flow_Rate",
                            }

                        ],
                    }
                }



            ]
    },
    "time-series-charts": {
        "menu": "Diagnostics",
        "title": "Time Series Charts",
        "linkTitle": "Time Series Charts",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            "title":"COP",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                        'ony2':'Temperature',
                        'extra-vars': [
                            {
                                'equipment_name': 'Weather',
                                'sensor_names': ['Temperature']
                            }
                        ]
                    }
                },
                {
                    'id': 123,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            },
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                yaxis: 'y2',
                                name: "Temperature",
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name:  "Header",
                                facility_name: "CRP",
                                name: "Main_Return_Temp",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {title: 'Cooling Load (kW)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                yaxis: 'y2',
                                name: "Temperature",
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {title: 'Power Consumption (kWh)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                yaxis: 'y2',
                                name: "Temperature",
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },


                        ],
                    }
                },
                {
                    'id': 12,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"CHWST & CHWRT",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {title: 'Temperature (°C)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                yaxis: 'y2',
                                name: "Temperature",
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                name: "CHWR_Temp",
                            },


                        ],
                    }
                },
            ]
    },
    "outdoor-temperature-charts": {
        "menu": "Diagnostics",
        "title": "Outdoor Temperature Charts",
        "linkTitle": "Outdoor Temperature Charts",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [

                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Header",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },


                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Overall Chiller COP"
                            }
                        },
                        'variable-x': 'Temperature',
                        'variable-y': 'COP',
                        'mode': 'markers',
                        'type': 'scatter',
                        'extra-vars': [
                            {
                                'equipment_name': 'Weather',
                                'sensor_names': ['Temperature']
                            }
                        ]
                    }
                },
                {
                    'id': 14,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },

                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "efficiency",
                            },


                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Comp_Power",
                            },



                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Cooling Load (kW)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Chiller1",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },
                            {
                                equipment_name: "Chiller2",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },
                            {
                                equipment_name: "Chiller3",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },
                            {
                                equipment_name: "Chiller4",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },
                            {
                                equipment_name: "Chiller5",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },
                            {
                                equipment_name: "Chiller6",
                                facility_name: "CRP",
                                mode: "markers",
                                name: "Cooling_Load"
                            },



                        ],
                    }
                },


            ]
    },

};